import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { LatteButton } from '../common';

const CTASection = ({ currentSession, onContinueConsulting, onStartNewConsulting }) => {
  return (
    <section className="cta-section">
      <div className="container">
        <h2 className="cta-title-modern">
          라떼 한 잔의 가치로, 커리어 풀세트 뽑아가세요
        </h2>
        <p className="cta-description-modern">
          30분 후, 당신의 대화는 완벽한 커리어 자산이 됩니다.
        </p>
        <div className="cta-button-wrapper">
          {currentSession ? (
            <LatteButton
              onClick={onContinueConsulting}
              size="xl"
              className="btn btn-gradient-modern"
            >
              <Clock className="w-5 h-5" />
              컨설팅 계속하기
              <ArrowRight className="w-5 h-5" />
            </LatteButton>
          ) : (
            <LatteButton
              onClick={onStartNewConsulting}
              size="xl"
              className="btn btn-gradient-modern"
            >
              지금 시작하기
              <ArrowRight className="w-5 h-5" />
            </LatteButton>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
